const setPortal = (state) => (portal) => ({
  ...state,
  portal: portal,
});

export default setPortal;
